import React, { useState, useEffect, useContext } from "react";
import { useParams, useLocation } from "react-router-dom";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import { useNavigate } from "react-router-dom";

import {
  Grid,
  Button,
  Tooltip,
  Typography,
  Checkbox,
  Card,
  TextField,
  CardContent,
  Radio,
  RadioGroup,
  FormControlLabel,
  Divider,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import AlertDialog from "../../components/AlertDialog.js";
import Autocomplete from "@mui/material/Autocomplete";
import Popper from "@material-ui/core/Popper";

import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";
import styled from "styled-components";

import dropdownImg from "../../assets/icons/dropdown.png";
import infoImg from "../../assets/icons/info.png";

import { GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY } from "../../graphQL/component_qry";
import { GET_FORM_DATA_BY_FORM_UUID } from "../../graphQL/form_qry";
import {
  REFRESH_TOKEN_MUTATION,
  STAFF_MODULE_ACCESS_QUERY,
} from "../../graphQL/user_qry";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const PopperMy = function (props) {
  return <Popper {...props} style={styles.popper} placement="bottom-start" />;
};

const styles = theme => ({
  popper: {
    width: "fit-content",
  },
});

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#DB3131",
        "&$error": {
          color: "#DB3131",
        },
      },
    },
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    marginLeft: "8rem",
    marginRight: "10rem",
    // marginTop: "2rem",
    textAlign: "center",
  },
  formContainer: {
    padding: theme.spacing(4),
    // marginTop: "2rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    backgroundColor: "#ffffff",
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#E3F2FD",
    },
  },
  radioLabelStyle: {
    "& .MuiTypography-body1": {
      fontSize: 16,
    },
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  autoComStyle: {
    "& .MuiAutocomplete-inputRoot": {
      borderRadius: 10,
      backgroundColor: "#E3F2FD",
    },
  },
  textFieldOnFormStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#E3F2FD",
    },
  },
  textFieldInput: {
    resize: "both",
    // maxHeight: "120px",
    minHeigth: "75px",
  },
}));

function FormPreview() {
  let tenantName = localStorage.getItem("tenantName")
    ? localStorage.getItem("tenantName")
    : "";
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });

  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else {
      window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const { formUuid } = useParams();

  let tenantUserId = 0;
  if (localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if (localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");

  const classes = useStyles();

  const [allComponents, setAllComponents] = useState([]);
  const [selectedVal, setSelectedVal] = useState("Select");
  const [loadData, setLoadData] = useState(true);
  const [formData, setFormData] = useState([]);
  const [remainedChars, setRemainedChars] = useState([]);
  const [tenantStates, setTenantStates] = useState([]);
  const [tenantCountries, setTenantCountries] = useState([]);
  const [formCreateDate, setFormCreatedate] = useState("");
  const [linkedinUrl, setLinkedinUrl] = useState("");

  const location = useLocation();

  const [previewAccess, setPreviewAccess] = useState(true);

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    },
  );

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to preview from form or term
    var formAccess = Boolean(false);
    var termAccess = Boolean(false);

    const {
      loading: accessDataLoading,
      error: accessDataError,
      data: accessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Forms",
        modulepageName: "List",
      },
    });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {
      console.log(accessData.staffModuleAccess);
      let formadditionalActions =
        accessData.staffModuleAccess.additionalActions.split("|");
      let commonActions = accessData.staffModuleAccess.commonActions.split("|");
      if (
        location.pathname.indexOf("/preview") != -1 &&
        location.pathname.indexOf("/preview-edit") == -1 &&
        formadditionalActions.find(a => a == "Preview")
      )
        formAccess = true;
      if (
        location.pathname.indexOf("/preview-edit") != -1 &&
        commonActions.find(a => a == "Edit")
      )
        formAccess = true;
    }

    const {
      loading: termAccessDataLoading,
      error: termAccessDataError,
      data: termAccessData,
    } = await checkStaffModuleAccess({
      variables: {
        tenantUserId: parseInt(tenantUserId),
        clientId: parseInt(clientId),
        moduleName: "Terms",
        modulepageName: "List",
      },
    });

    if (!termAccessDataLoading && termAccessData && termAccessData.staffModuleAccess) {
      let termAdditionalActions =
        termAccessData.staffModuleAccess.additionalActions.split("|");
      if (termAdditionalActions.find(a => a == "Preview Form")) termAccess = true;
    }

    if (
      termAccessDataError &&
      termAccessDataError.graphQLErrors &&
      termAccessDataError.graphQLErrors[0].message === "Signature has expired"
    ) {
      navigate(`${project_url}/signin`);
    }

    if (formAccess == true || termAccess == true) setPreviewAccess(true);
    else setPreviewAccess(false);
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const [getFormData] = useManualQuery(GET_FORM_DATA_BY_FORM_UUID, {
    fetchPolicy: "network-only",
  });

  const getFormComponents = async () => {
    if (formUuid) {
      // Get form information
      const {
        loading: formDataLoading,
        error: formDataError,
        data: formData,
      } = await getFormData({
        variables: { formUuid: formUuid },
      });

      if (!formDataLoading && formData && formData.getFormDataByFormUuid) {
        setFormData(formData.getFormDataByFormUuid);

        setTenantStates(
          formData.getFormDataByFormUuid.clientId.tenantId.statesList.map(
            ({ name }) => name,
          ),
        );
        setTenantCountries(
          formData.getFormDataByFormUuid.clientId.tenantId.countriesList.map(
            ({ name }) => name,
          ),
        );
      }
      if (
        formDataError &&
        formDataError.graphQLErrors &&
        formDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }

      // Get form components information
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: formUuid },
      });

      if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        console.log(
          "allComponents----",
          formComponentsAnswersData.formComponentAnswerList.componentList,
        );
        setLoadData(false);
        setAllComponents(formComponentsAnswersData.formComponentAnswerList.componentList);
        var remChars = [];
        formComponentsAnswersData.formComponentAnswerList.componentList.map(
          (component, index) => remChars.push({ index: index, charNo: null }),
        );
        setRemainedChars(remChars);
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  useEffect(() => {
    (() => getFormComponents())();
  }, [formUuid]);

  useEffect(() => {
    if (formData.createDate) {
      setFormCreatedate(dayFormat(formData.createDate));
    }
  }, [formData]);

  const convertTxtToRichTxt = txt => {
    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //Commented by Sami 30Aug2025
    let contentHTML = draftToHtml(JSON.parse(txt));
    contentHTML = contentHTML.replace(/<p>/, "");
    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      },
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const updRemainedChars = (input, maxChar, indx) => {
    if (remainedChars) {
      const remCharsList = findAnd.changeProps(
        remainedChars,
        { index: indx },
        {
          charNo: maxChar - input.length,
        },
      );
      setRemainedChars(remCharsList);
    }
  };

  const formatter = new Intl.DateTimeFormat("en-us", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  const dayFormat = day => {
    const dayDate = new Date(day);
    const dayFormat = formatter.formatToParts(dayDate);
    const newFormat =
      dayFormat.find(a => a.type == "month").value +
      "/" +
      dayFormat.find(a => a.type == "day").value +
      "/" +
      dayFormat.find(a => a.type == "year").value;
    return newFormat;
  };

  const handleLinkedInChange = e => {
    setLinkedinUrl(e.target.value);
  };

  const openLinkedIn = () => {
    if (!linkedinUrl?.trim()) return;

    let url = linkedinUrl.trim();

    if (!/^https?:\/\//i.test(url)) {
      url = `https://${url}`;
    }

    try {
      const parsedUrl = new URL(url);

      if (!parsedUrl.hostname.includes("linkedin.com")) {
        alert("Please enter a valid LinkedIn URL.");
        return;
      }

      window.open(parsedUrl.href, "_blank", "noopener,noreferrer");
    } catch {
      alert("Please enter a valid URL.");
    }
  };

  if (loadData) return;
  if (previewAccess)
    return (
      <div className={classes.root}>
        <Box
          style={{
            textAlign: "center",
            marginBottom: 20,
          }}
        >
          <Typography
            variant="h1"
            style={{
              fontSize: 28,
              fontWeight: 600,
            }}
          >
            Form Preview
          </Typography>
        </Box>
        <Box
          style={{
            textAlign: "left",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <Typography
            variant="h2"
            style={{
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            Form Name: <b>{formData.name}</b>
          </Typography>
        </Box>
        <Box
          style={{
            textAlign: "left",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <Typography
            variant="h2"
            style={{
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            Date Created: <b>{formCreateDate}</b>
          </Typography>
        </Box>
        <Box
          style={{
            textAlign: "left",
            marginTop: 10,
            marginBottom: 10,
          }}
        >
          <Typography
            variant="h2"
            style={{
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            Status: <b>{formData.approved ? "Published" : "Draft"}</b>
          </Typography>
        </Box>
        <Box
          style={{
            textAlign: "left",
            marginTop: 10,
            marginBottom: 20,
          }}
        >
          <Typography
            variant="h2"
            style={{
              fontSize: 16,
              fontWeight: 500,
            }}
          >
            Terms Using This Form:{" "}
            <b>{formData.formPreviwTerms !== "" ? formData.formPreviwTerms : "None"}</b>
          </Typography>
        </Box>
        <div className={classes.formContainer}>
          <Grid item lg md xl xs>
            <Card>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15, marginBottom: 25 }}>
                  <b>
                    We need to create a profile for you to track your volunteer
                    application. Please provide the following information. If you are a
                    returning applicant, enter the email address you used last time you
                    applied.
                  </b>
                </Typography>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  First Name
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 30,
                  }}
                  style={{
                    width: 300,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                />
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  Last Name
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 30,
                  }}
                  style={{
                    width: 300,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                />
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  Email
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 100,
                  }}
                  style={{
                    width: 930,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                />
                <Typography
                  variant="h3"
                  style={{
                    fontSize: 14,
                    display: "flex",
                    alignItems: "center",
                    marginLeft: 50,
                    marginTop: 5,
                  }}
                >
                  If you are a returning applicant, enter the email address you used last
                  time you applied.
                </Typography>
              </Box>

              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  LinkedIn URL
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 150,
                  }}
                  style={{
                    width: 930,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                  onChange={handleLinkedInChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          edge="end"
                          onClick={openLinkedIn}
                          disabled={!linkedinUrl || !linkedinUrl.trim()}
                          title={
                            linkedinUrl && linkedinUrl.trim()
                              ? "View LinkedIn page"
                              : "Enter a LinkedIn URL"
                          }
                        >
                          <OpenInNewIcon />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box>

              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  Phone No
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 30,
                  }}
                  style={{
                    width: 300,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                />
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  City
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <TextField
                  id="outlined-multiline-static"
                  variant="outlined"
                  className={classes.textFieldStyle}
                  inputProps={{
                    maxLength: 30,
                  }}
                  style={{
                    width: 300,
                    marginTop: 15,
                    marginLeft: 50,
                  }}
                />
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  State
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    key={selectedVal}
                    options={tenantStates}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => option}
                    sx={{ width: 400 }}
                    renderInput={params => (
                      <TextField
                        style={{
                          width: 300,
                          marginTop: 15,
                          marginLeft: 5,
                        }}
                        label="Select"
                        margin="normal"
                        name="selectOptions"
                        variant="outlined"
                        {...params}
                        id="state"
                      />
                    )}
                  />
                </form>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: 45,
                }}
              >
                <Typography variant="h3" style={{ paddingLeft: 15 }}>
                  Country
                </Typography>
                <StyledTooltip title="required field">
                  <Typography
                    variant="h3"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#E53935",
                      paddingLeft: 5,
                      paddingRight: 5,
                    }}
                  >
                    *
                  </Typography>
                </StyledTooltip>
              </Box>
              <Box
                pb={0.25}
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <form noValidate autoComplete="off">
                  <Autocomplete
                    className={classes.autoComStyle}
                    key={selectedVal}
                    options={tenantCountries}
                    PopperComponent={PopperMy}
                    getOptionLabel={option => option}
                    sx={{ width: 400 }}
                    renderInput={params => (
                      <TextField
                        style={{
                          width: 300,
                          marginTop: 15,
                          marginLeft: 5,
                        }}
                        label="Select"
                        margin="normal"
                        name="selectOptions"
                        variant="outlined"
                        {...params}
                        id="state"
                      />
                    )}
                  />
                </form>
              </Box>
              <Divider
                style={{
                  width: "100%",
                  height: "2px",
                  marginTop: 50,
                  marginBottom: 50,
                }}
              />
              {allComponents.map((component, index) => (
                <Box>
                  <List
                    sx={{
                      paddingTop: 0,
                      paddingBottom: 3,
                      "& .MuiListItemButton-root:hover": {
                        backgroundColor: "transparent",
                      },
                    }}
                  >
                    <ListItemButton
                      disableRipple
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "space-between",
                        paddingLeft: 10,
                        paddingTop: 5,
                        paddingBottom: 0,
                        cursor: "default",
                      }}
                    >
                      <Box
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          paddingTop: 10,
                        }}
                      >
                        <Box
                          style={{
                            display: "flex",
                            flexDirection: "row",
                          }}
                        >
                          {component.tooltip !== "" &&
                          component.answerTypeId.name !== "content" ? (
                            <StyledTooltip title={component.tooltip}>
                              <img
                                style={{
                                  paddingBottom: 3,
                                  height: 24,
                                  paddingTop:
                                    component.answerTypeId.name === "checkbox_single" &&
                                    8,
                                }}
                                src={infoImg}
                              />
                            </StyledTooltip>
                          ) : (
                            ""
                          )}
                        </Box>
                        <Typography variant="h3">
                          <div
                            style={{
                              wordBreak: "break-word",
                              paddingLeft: 5,
                            }}
                          >
                            {component.answerTypeId.name === "checkbox_single" &&
                              component.answerList.length == 1 &&
                              component.mandatory && (
                                <>
                                  <span
                                    style={{
                                      color: "#E53935",
                                      verticalAlign: "sub",
                                    }}
                                  >
                                    {" "}
                                    *
                                  </span>
                                  <Checkbox />
                                </>
                              )}
                            {component.answerTypeId.name === "checkbox_single" &&
                              component.answerList.length == 1 &&
                              !component.mandatory && <Checkbox />}

                            {component.label ? convertTxtToRichTxt(component.label) : ""}
                          </div>
                        </Typography>
                      </Box>
                    </ListItemButton>

                    <CardContent
                      style={{
                        paddingTop: 5,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                        marginLeft: 30,
                      }}
                    >
                      {component.caption &&
                        //JSON.parse(component.caption.replace(/'/g, '"')).blocks[0].text !==
                        //Commented by Sami 30Aug2025
                        JSON.parse(component.caption).blocks[0].text !== "" && (
                          <Typography
                            variant="h3"
                            style={{
                              fontSize: 14,
                              display: "flex",
                              alignItems: "center",
                              paddingBottom: 0,
                            }}
                          >
                            <div
                              style={{
                                textAlign: "left",
                                wordBreak: "break-word",
                                paddingLeft: 5,
                              }}
                            >
                              {convertTxtToRichTxt(component.caption)}
                            </div>
                          </Typography>
                        )}
                      {(component.answerTypeId.name === "text" ||
                        component.answerTypeId.name === "textarea") && (
                        <>
                          <Box
                            pb={0.25}
                            style={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <Typography
                              variant="h3"
                              style={{
                                fontSize: 14,
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: 5,
                              }}
                            >
                              Answer
                            </Typography>
                            {component.mandatory && (
                              <StyledTooltip title="required field">
                                <Typography
                                  variant="h3"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#E53935",
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                  }}
                                >
                                  *
                                </Typography>
                              </StyledTooltip>
                            )}
                          </Box>
                          {component.answerTypeId.name === "text" && (
                            <TextField
                              id="outlined-multiline-static"
                              variant="outlined"
                              className={classes.textFieldStyle}
                              inputProps={{
                                maxLength: component.answerList[0].maxLength,
                              }}
                              fullWidth={component.answerList[0].maxLength > 150}
                              style={{
                                width:
                                  component.answerList[0].maxLength >= 5
                                    ? component.answerList[0].maxLength <= 100
                                      ? component.answerList[0].maxLength * 12
                                      : null
                                    : 80,
                              }}
                              onChange={e => {
                                updRemainedChars(
                                  e.target.value,
                                  component.answerList[0].maxLength,
                                  index,
                                );
                              }}
                            />
                          )}
                          {component.answerTypeId.name === "textarea" && (
                            <Box style={{ width: "fit-content" }}>
                              <TextField
                                id="outlined-multiline-static"
                                variant="outlined"
                                multiline
                                inputProps={{
                                  maxLength: component.answerList[0].maxLength,
                                }}
                                style={{
                                  minWidth: component.answerList[0].width * 10,
                                  maxWidth: "1350px",
                                }}
                                rows={component.answerList[0].height}
                                className={classes.textFieldOnFormStyle}
                                InputProps={{
                                  classes: {
                                    input: classes.textFieldInput,
                                  },
                                }}
                                onChange={e => {
                                  updRemainedChars(
                                    e.target.value,
                                    component.answerList[0].maxLength,
                                    index,
                                  );
                                }}
                              />
                            </Box>
                          )}
                          <Typography
                            variant="h6"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              paddingRight: 5,
                              paddingTop: 5,
                              color: "#00000099",
                            }}
                          >
                            {component.answerList &&
                            component.answerList[0] &&
                            component.answerList[0].maxLength
                              ? remainedChars.length &&
                                remainedChars[index].charNo !== null
                                ? remainedChars[index].charNo +
                                  " of " +
                                  component.answerList[0].maxLength +
                                  " Character(s) left"
                                : component.answerList[0].maxLength +
                                  " of " +
                                  component.answerList[0].maxLength +
                                  " Character(s) left"
                              : ""}
                          </Typography>
                        </>
                      )}
                      {component.answerTypeId.name === "drop_down" && (
                        <ThemeProvider theme={formLabelsTheme}>
                          <form noValidate autoComplete="off">
                            <Autocomplete
                              className={classes.autoComStyle}
                              key={selectedVal}
                              options={component.answerList.map(({ label }) => label)}
                              disableClearable
                              PopperComponent={PopperMy}
                              getOptionLabel={option => option}
                              sx={{ width: 400 }}
                              renderInput={params => (
                                <TextField
                                  required={component.mandatory}
                                  label={
                                    selectedVal === "Select"
                                      ? "Select"
                                      : selectedVal === "Use State"
                                        ? "Select State"
                                        : "Select Country"
                                  }
                                  margin="normal"
                                  name="selectOptions"
                                  id="selectOptions"
                                  variant="outlined"
                                  {...params}
                                />
                              )}
                            />
                          </form>
                        </ThemeProvider>
                      )}
                      {component.answerTypeId.name === "radio_button" && (
                        <>
                          {component.mandatory && (
                            <Box
                              pb={0.25}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Typography
                                variant="h3"
                                style={{
                                  fontSize: 14,
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: 5,
                                }}
                              >
                                Required
                              </Typography>
                              <StyledTooltip title="required field">
                                <Typography
                                  variant="h3"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#E53935",
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                  }}
                                >
                                  *
                                </Typography>
                              </StyledTooltip>
                            </Box>
                          )}
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            name="radio-buttons-group"
                          >
                            {component.answerList &&
                              component.answerList
                                .map(({ label }) => label)
                                .map((option, index) => (
                                  <FormControlLabel
                                    value={option}
                                    control={<Radio />}
                                    label={option}
                                    className={classes.radioLabelStyle}
                                  />
                                ))}
                          </RadioGroup>
                        </>
                      )}

                      {component.answerTypeId.name === "checkbox_multiple" && (
                        <>
                          {component.answerList.length > 0 && component.mandatory && (
                            <Box
                              pb={0.25}
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              <Typography
                                variant="h3"
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  paddingLeft: 5,
                                  paddingRight: 5,
                                  fontSize: 14,
                                }}
                              >
                                <div>
                                  Required <span style={{ color: "#E53935" }}> *</span>
                                </div>
                              </Typography>
                            </Box>
                          )}
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "column",
                            }}
                          >
                            {component.answerList
                              .map(({ label }) => label)
                              .map((element, index) => (
                                <FormControlLabel
                                  control={<Checkbox />}
                                  label={element}
                                />
                              ))}
                          </Box>
                        </>
                      )}
                    </CardContent>
                  </List>
                </Box>
              ))}
              <Box
                mt={5}
                ml={2}
                //  mb={3}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.buttonStyle}
                  style={{ marginRight: 2 }}
                  onClick={() => window.close()}
                >
                  Done
                </Button>
              </Box>
            </Card>
          </Grid>
        </div>
      </div>
    );
  else
    return (
      <div className={classes.root}>
        <div className={classes.container}>
          <AlertDialog
            title="No Permission"
            contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
            closeDialog={() => {
              navigate(`${project_url}/tenant/dashboard`);
            }}
          />
        </div>
      </div>
    );
}

export default FormPreview;
